import axios from 'axios';
import { useToastStore } from '@/stores/useToastStore';

let installed = false;

/**
 * Globální axios response interceptor — při HTTP 403 zobrazí toast
 * "Nemáte oprávnění". Volá se jen jednou (idempotentně) z bootstrapu.
 *
 * 401 ponecháme komponentám (login flow).
 */
export function installAxiosInterceptors() {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error?.response?.status;
      if (status === 403) {
        const message =
          error?.response?.data?.message ?? 'Tato akce vyžaduje vyšší oprávnění než máte.';
        useToastStore.getState().showToast({
          type: 'error',
          title: 'Nemáte oprávnění',
          message,
          duration: 5000,
        });
      }
      return Promise.reject(error);
    }
  );
}
